import Link from 'next/link';
import styled from 'styled-components';

import { theme } from './GlobalStyles';

const Breadcrumbs = styled.ul`
  text-align: center;
  list-style: none;
  padding: 0;
  margin: 1.875rem 0;
  & > li:after {
    color: ${theme.colors.purple};
    content: '${(props) => props.separator || '/'}';
    padding: 0 0.5rem;
  }
`;

const Crumb = styled.li`
  display: inline-block;
  &:last-of-type:after {
    content: '';
    padding: 0;
  }
  a {
    color: ${theme.colors.purple};
    text-decoration: none;
    &:hover,
    &:active {
      text-decoration: underline;
    }
  }
`;
const BreadCrumbs = ({ routes }) => {
  const { prev, curr } = routes;
  return (
    <Breadcrumbs>
      <Crumb>
        <Link href="/">Home</Link>
      </Crumb>
      {prev?.map((x, i) => {
        return (
          <Crumb key={`crumbId${i}`}>
            <Link href={x.url} legacyBehavior>
              {x.name}
            </Link>
          </Crumb>
        );
      })}
      <Crumb>{curr.name}</Crumb>
    </Breadcrumbs>
  );
};

export default BreadCrumbs;
